export default {
  GET_ALL_CONFLICTS: (state) => {
    return state.conflicts;
  },
};
